module.exports = __webpack_public_path__ + "static/img/hero-bg.c7bacf37.webp";